/* New City · motion leggero
   1) Comparsa morbida di titoli, testi e card in tutto il sito (solo opacity/transform, controllo leggero allo scroll).
   2) Scorrimento con rotella più morbido e un po' più lento su desktop (mouse/trackpad), nativo su touch.
   Attivo sempre (anche con "riduci movimento" del sistema, su richiesta), disattivato solo nell'editor del tema. */
(function () {
  'use strict';
  var d = document, w = window, html = d.documentElement;
  var design = w.Shopify && w.Shopify.designMode;
  if (design) return;

  /* ---------- 1. Reveal (tutto il sito) ---------- */
  function initReveal() {
    if (!d.body || !w.requestAnimationFrame) return;
    var isHome = d.body.classList.contains('template-index');

    var st = d.createElement('style');
    st.textContent =
      'html.nc-motion [data-nc-rv]{opacity:0;transition:opacity .75s cubic-bezier(.2,.7,.2,1),transform .75s cubic-bezier(.2,.7,.2,1)!important;transition-delay:calc(var(--nc-rv-d,0)*80ms)!important}' +
      'html.nc-motion [data-nc-rv="up"]{transform:translate3d(0,24px,0)}' +
      'html.nc-motion [data-nc-rv].nc-rv-in{opacity:1}' +
      'html.nc-motion [data-nc-rv="up"].nc-rv-in{transform:none}';
    d.head.appendChild(st);
    html.classList.add('nc-motion');

    var SEL = '.nc-eyebrow,h2,h3,p,.btn,form,.nc-usp__item,.nc-cat,.nc-marquee,.grid-link,' +
      '.feature-row__image,.nc-promo__media,.nc-bkcta__hours,.nc-bkcta__media';
    var main = d.querySelector('main') || d.body;
    var sections = Array.prototype.slice.call(main.querySelectorAll('.shopify-section'));
    if (!isHome) sections.push(main); /* contenuti delle pagine fuori dalle sezioni */
    var vh = w.innerHeight, targets = [];

    sections.forEach(function (sec) {
      if (sec.id === 'shopify-section-nc_hero_slider' || sec.offsetHeight === 0) return;
      var found = Array.prototype.slice.call(sec.querySelectorAll(SEL)).filter(function (el) {
        if (sec === main && el.closest('.shopify-section')) return false;
        if (el.hasAttribute('data-nc-rv')) return false;
        if (el.closest('.nc-promo__body, [data-nc-slider], .nc-cookie, [aria-hidden="true"], .drawer, .modal')) return false;
        if (!isHome && (el.tagName === 'FORM' || el.closest('form'))) return false; /* moduli (prodotto, carrello, prenotazione): sempre visibili */
        if (sec.id.indexOf('1588313775907') > -1 && !/^H2$/.test(el.tagName)) return false; /* feed Instagram: solo titolo */
        if (!el.offsetWidth && !el.offsetHeight) return false;
        if (el.tagName === 'P' && !el.textContent.trim()) return false;
        return true;
      });
      /* tieni solo gli elementi "esterni" (niente doppie animazioni annidate) */
      found = found.filter(function (el) {
        for (var p = el.parentElement; p && p !== sec; p = p.parentElement) if (found.indexOf(p) > -1) return false;
        return true;
      });
      found.forEach(function (el) {
        if (el.getBoundingClientRect().top < vh * 0.92) return; /* già visibile al caricamento: nessun flash */
        var tf = w.getComputedStyle(el).transform;
        el.setAttribute('data-nc-rv', tf && tf !== 'none' ? 'fade' : 'up');
        targets.push(el);
      });
    });
    if (!targets.length) return;

    function done(el) {
      el.removeAttribute('data-nc-rv');
      el.classList.remove('nc-rv-in');
      el.style.removeProperty('--nc-rv-d');
    }
    /* controllo a ogni frame di scroll: rivela anche ciò che è stato superato con salti veloci (Fine, link, ecc.) */
    var pending = targets.slice(), ticking = false;
    function onScroll() { if (!ticking) { ticking = true; w.requestAnimationFrame(check); } }
    function check() {
      ticking = false;
      var lim = w.innerHeight * 0.9, batch = [];
      pending = pending.filter(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < lim) { batch.push({ el: el, t: r.top, l: r.left }); return false; }
        return true;
      });
      batch.sort(function (a, b) { return (Math.round(a.t / 40) - Math.round(b.t / 40)) || (a.l - b.l); });
      batch.forEach(function (o, i) {
        var el = o.el;
        el.style.setProperty('--nc-rv-d', Math.min(i, 5));
        el.classList.add('nc-rv-in');
        var t = setTimeout(function () { done(el); }, 1600);
        el.addEventListener('transitionend', function te(ev) {
          if (ev.target !== el || ev.propertyName !== 'opacity') return;
          el.removeEventListener('transitionend', te);
          clearTimeout(t); done(el);
        });
      });
      if (!pending.length) {
        w.removeEventListener('scroll', onScroll);
        w.removeEventListener('resize', onScroll);
      }
    }
    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', onScroll, { passive: true });
    check();
  }

  /* ---------- 2. Smooth wheel (desktop) ---------- */
  function initSmoothWheel() {
    if (!w.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var EASE = 0.1;   /* inerzia (più basso = più morbido) */
    var SPEED = 0.8;  /* velocità rispetto al nativo */
    var target = w.scrollY, cur = w.scrollY, lastY = w.scrollY, running = false, lastT = 0;

    function maxY() { return Math.max(0, (d.scrollingElement || html).scrollHeight - w.innerHeight); }
    function locked() {
      var h = w.getComputedStyle(html).overflowY, b = w.getComputedStyle(d.body).overflowY;
      return h === 'hidden' || b === 'hidden' || h === 'clip' || b === 'clip';
    }
    function innerScrollable(el, dy) {
      for (; el && el !== d.body && el !== html; el = el.parentElement) {
        if (el.nodeType !== 1) continue;
        var oy = w.getComputedStyle(el).overflowY;
        if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') && el.scrollHeight > el.clientHeight + 1) {
          if (dy < 0 ? el.scrollTop > 0 : el.scrollTop + el.clientHeight < el.scrollHeight - 1) return true;
        }
      }
      return false;
    }
    function tick(t) {
      if (Math.abs(w.scrollY - lastY) > 2) { running = false; target = cur = w.scrollY; return; } /* scrollbar/tastiera: lascia fare */
      var dt = lastT ? Math.min(t - lastT, 50) : 16.7; lastT = t;
      var k = 1 - Math.pow(1 - EASE, dt / 16.7);
      cur += (target - cur) * k;
      if (Math.abs(target - cur) < 0.5) cur = target;
      w.scrollTo(0, cur);
      lastY = w.scrollY;
      if (cur !== target) w.requestAnimationFrame(tick); else running = false;
    }
    w.addEventListener('wheel', function (e) {
      if (e.defaultPrevented || e.ctrlKey || e.metaKey || e.shiftKey) return;
      var dy = e.deltaY;
      if (!dy || Math.abs(e.deltaX) > Math.abs(dy)) return;
      if (e.deltaMode === 1) dy *= 16; else if (e.deltaMode === 2) dy *= w.innerHeight;
      if (locked() || innerScrollable(e.target, dy)) return;
      e.preventDefault();
      if (!running) { target = cur = lastY = w.scrollY; lastT = 0; }
      target = Math.max(0, Math.min(maxY(), target + dy * SPEED));
      if (!running) { running = true; w.requestAnimationFrame(tick); }
    }, { passive: false });
    w.addEventListener('scroll', function () { if (!running) { target = cur = lastY = w.scrollY; } }, { passive: true });
  }

  function start() { initReveal(); initSmoothWheel(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();